import type { ContentTocItem } from '~/utils/contentToc'

export const useContentTocState = () => ({
  items: useState<ContentTocItem[]>('blog-content-toc-items', () => []),
  floating: useState('blog-content-toc-floating', () => false),
  activeId: useState('blog-content-toc-active-id', () => '')
})
